export const REQUEST_STATUS_NAMES = {
  WORK: 'Заявка ждёт проверки',
  NEW: 'Новая',
  IN_EDIT: 'На редактировании',
  MISTAKE: 'Ошибка в заявке',
  COMPLETED: 'Выполнено',
  DONE: 'Выдано',
  CANCELLED: 'Отменена',
  REJECTED: 'Отклонена',
  REQUEST_RETURN: 'Запрос на редактирование',
  CHECK_FINISHED: 'Проверка завершена',
  SLS_WAS_APPOINTED: 'Назначен специалист по установке',
  IN_WORK: 'В работе',
} as const;

export type RequestStatusNameValue =
  (typeof REQUEST_STATUS_NAMES)[keyof typeof REQUEST_STATUS_NAMES];

/**
 * ID статусов заявок (таблица logisticRequestStatuses).
 * Используется в новом коде вместо проверок по названию статуса (SYST-3029).
 */
export enum RequestStatusId {
  NEW = 1,
  COMPLETED = 3,
  REQUEST_RETURN = 6,
  IN_EDIT = 7,
  CHECK_FINISHED = 8,
  WORK = 9,
  IN_WORK = 10,
  DONE = 11,
  SLS_WAS_APPOINTED = 12,
  MISTAKE = 13,
  CANCELLED = 14,
  REJECTED = 15,
}

export const REQUEST_STATUS_ID_TO_NAME = {
  '1': REQUEST_STATUS_NAMES.NEW,
  '3': REQUEST_STATUS_NAMES.COMPLETED,
  '6': REQUEST_STATUS_NAMES.REQUEST_RETURN,
  '7': REQUEST_STATUS_NAMES.IN_EDIT,
  '8': REQUEST_STATUS_NAMES.CHECK_FINISHED,
  '9': REQUEST_STATUS_NAMES.WORK,
  '10': REQUEST_STATUS_NAMES.IN_WORK,
  '11': REQUEST_STATUS_NAMES.DONE,
  '12': REQUEST_STATUS_NAMES.SLS_WAS_APPOINTED,
  '13': REQUEST_STATUS_NAMES.MISTAKE,
  '14': REQUEST_STATUS_NAMES.CANCELLED,
  '15': REQUEST_STATUS_NAMES.REJECTED,
  '16': REQUEST_STATUS_NAMES.REJECTED,
} as const;
